import { memoize } from 'lodash';
import { StylesConfig } from 'react-select';

export const getStyles = memoize(
  (customStyles: StylesConfig, isMobile: boolean): StylesConfig => ({
    singleValue: (base, state) => ({
      ...base,
      fontSize: 16,
      lineHeight: '20px',
      textOverflow: 'clip',
      fontWeight: state.selectProps.menuIsOpen ? 400 : 600,
      color: state.selectProps.menuIsOpen ? '#d6d5c9' : '#17181a', // lightGrey : blackBase from Theme.colors;'
      ...customStyles.singleValue?.(base, state),
    }),
    control: (base, state) => {
      const height = isMobile ? 40 : 45;
      const borderRadius = isMobile ? 6 : 0;
      const boxShadow = isMobile ? 'inset 0 0 0 1px #d6d5c3' : '';
      const onHover = { cursor: 'pointer' };
      return {
        ...base,
        position: 'relative',
        border: 0,
        borderRadius,
        boxShadow,
        '&:hover': onHover,
        height,
        ...customStyles.control?.(base, state),
      };
    },
    option: (base, state) => ({
      ...base,
      color: 'black',
      '&:hover': { backgroundColor: '#e6f2ff', cursor: 'pointer' },
      backgroundColor: state.isFocused ? '#e6f2ff' : '#ffffff',
      ...customStyles.option?.(base, state),
    }),
    menu: (base, state) => ({
      ...base,
      zIndex: 9999,
      ...customStyles.menu?.(base, state),
    }),
    menuList: (base, state) => ({
      ...base,
      zIndex: 9999,
      padding: 0,
      ...customStyles.menuList?.(base, state),
    }),
    valueContainer: (base, state) => ({
      ...base,
      display: 'flex',
      ...customStyles.valueContainer?.(base, state),
    }),
  })
);
